(() => {
  // app/scripts/filter-component.js
  var { debounceTime, addEvent } = theme;
  customElements.define("filter-component", class extends HTMLElement {
    constructor() {
      super();
      this.container = this.closest("[data-section-id]");
      this.cache = [];
      this.andLogic = JSON.parse(this.dataset.andLogic || "false");
      this.filterType = this.dataset.type || "attribute";
      this.form = this.querySelector("form");
      this.inputClass = `input[form="${this.form.id}"]`;
    }
    connectedCallback() {
      this.addEvents();
    }
    addEvents() {
      this.addEventListener("change", ({ target }) => {
        let selectedTarget = target;
        if (selectedTarget.name == "sortBy") {
          const sortEl = [...this.querySelectorAll("[name=sort_by]")].find((item) => item.value == selectedTarget.value);
          sortEl.checked = true;
          selectedTarget = sortEl;
        }
        if (selectedTarget.name == "paginateViewClone") {
          const element = [...document.querySelectorAll("[name=paginateView]")].find((item) => item.value == selectedTarget.value);
          element.checked = true;
          element.closest("cart-update-component").setValue = element;
          return;
        }
        this.onChange(selectedTarget);
      });
      this.form.addEventListener("submit", (e) => {
        e.preventDefault();
        this.submit();
      });
      this.querySelector(".jsFilterReset")?.addEventListener("click", (e) => {
        e.preventDefault();
        this.uncheckInput();
        this.submit();
      });
      this.removeFilter();
      this.filterSearch();
    }
    onChange(target) {
      const input = target;
      !this.andLogic && this.uncheckInput(input);
      if (target.hasAttribute("auto-submit"))
        this.submit();
    }
    uncheckInput(input = null) {
      let inputList;
      if (input) {
        inputList = this.querySelectorAll(`input[name="${input.name}"][form="${this.form.id}"]:not([id="${input.id}"])`);
      } else {
        inputList = this.querySelectorAll(`input[form="${this.form.id}"]`);
      }
      inputList.forEach((i) => {
        i.removeAttribute("checked");
        i.checked = false;
      });
    }
    get getQueryString() {
      const formData = new FormData(this.form);
      const query = new URLSearchParams(formData);
      if (this.filterType == "attribute")
        return query.toString();
      const arrayFilter = [];
      let sort = "";
      query.split("&").map((i) => {
        !i.includes("sort_by=") ? arrayFilter.push(i.split("=")[1]) : sort = i;
      });
      return arrayFilter.join("+") + (sort.length ? `?${sort}` : "");
    }
    submit() {
      const query = this.getQueryString;
      const findInCache = this.cache.find((i) => i.query == query);
      if (findInCache) {
        this.render(findInCache.DOM, findInCache.query);
        return;
      }
      let url = this.form.action;
      url += this.filterType == "attribute" ? "?" : "/";
      url += query;
      url += this.filterType == "attribute" || query.includes("?") ? "&" : "?";
      url += `section_id=${this.dataset.sectionId}`;
      fetch(url).then((e) => e.text()).then((html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        this.cache.push({
          query,
          DOM: div
        });
        this.render(div, query);
      });
    }
    render(result, searchParams = null) {
      if (searchParams) {
        let splitCharacter = this.filterType == "attribute" ? "?" : !searchParams.includes("?") || searchParams.includes("?") && searchParams.split("?")[0].length ? "/" : "";
        history.pushState({ searchParams }, "", `${this.form.action}${searchParams && splitCharacter.concat(searchParams)}`);
      }
      this.querySelectorAll(this.inputClass).forEach((input, i) => {
        if (!input.id)
          return;
        input.checked = result.querySelector(`#${input.id}`)?.checked || false;
      });
      this.querySelector("#" + this.dataset.product).innerHTML = result.querySelector("#" + this.dataset.product).innerHTML;
      this.querySelectorAll(".jsFilterUpdate")?.forEach((item) => {
        const newItem = result.querySelector(`[class="${item.className}"]`);
        if (!newItem)
          return;
        item.innerHTML = newItem.innerHTML;
      });
      this.removeFilter();
    }
    removeFilter() {
      this.querySelectorAll(".jsFilterRemove")?.forEach((item) => {
        item.addEventListener("click", (event) => {
          event.preventDefault();
          const value = item.querySelector(".jsValue").textContent;
          this.querySelectorAll(`input[form="${this.form.id}"]`).forEach((item2) => {
            if (item2.value != value)
              return;
            item2.checked = false;
          });
          this.submit();
        });
      });
    }
    filterSearch() {
      this.querySelectorAll(".jsFilterSearch")?.forEach((item) => {
        const parentEl = item.closest(".filter-block");
        item.addEventListener("click", () => {
          const value = item.previousElementSibling.value;
          searchFilterValue(parentEl, value);
        });
        item.previousElementSibling.addEventListener("keyup", (e) => {
          (e.keyCode == 8 || !item.previousElementSibling.value.length) && clearField(parentEl);
          const value = item.previousElementSibling.value;
          searchFilterValue(parentEl, value);
        });
      });
      const clearField = (el) => {
        el.querySelectorAll("li.matched")?.forEach((item) => item.classList.remove("matched"));
      };
      const searchFilterValue = (container, value) => {
        const filterListItem = container.querySelectorAll("[name*=filter]");
        if (value.length) {
          container.classList.add("searching");
          filterListItem.forEach((item) => {
            let regex = new RegExp(value, "i");
            const parentEl = item.closest("li");
            parentEl.classList.toggle("matched", item.value.match(regex));
          });
        } else {
          container.classList.remove("searching");
          container.querySelectorAll(".matched")?.forEach((item) => item.classList.remove("matched"));
        }
        container.querySelector(".jsFilterShowMore")?.classList.toggle("none", value.length);
      };
    }
  });
  addEvent("click", ".jsFilterShowMore", ({ target }) => {
    const container = target.closest(".filter-block");
    const filterList = container.querySelectorAll(".jsFilterToggle.none");
    filterList.forEach((item, value) => {
      value < 10 && item.classList.remove("none");
    });
    const hiddenFilterCount = container.querySelectorAll(".jsFilterToggle.none").length;
    !hiddenFilterCount && target.classList.add("none");
    target.querySelector(".attr-count").setAttribute("data-count", Math.min(10, hiddenFilterCount));
  });
})();
